import React from 'react';
import { ShieldCheckIcon, StarIcon, ZapIcon } from 'lucide-react';
import { CTAButton } from './CTAButton';
import { CHECKOUT_URL, OFFER_ANCHOR, PRICE_FULL, PRICE_TODAY, PRODUCT_ALT, PRODUCT_IMG } from './constants';
export function FinalCTA() {
  return <section className="border-t-4 border-brand-gold bg-brand-navy px-4 py-4 text-white" data-id="element-43" data-mp="c4fwemadn1rc">
      <div className="mx-auto max-w-3xl text-center" data-id="element-44" data-mp="87js0fnfcgiv">
        <p className="mb-1 font-display text-xl uppercase leading-none tracking-wide text-brand-gold sm:text-3xl" data-id="element-45" data-mp="m3wzqx25p3k5">
          One Last Opportunity
        </p>
        <div className="mx-auto mb-2 max-w-2xl space-y-1 text-[13px] font-medium leading-snug text-white/85 sm:text-base" data-id="element-46" data-mp="vuruyqxdrdhq">
          <p data-id="element-47" data-mp="qveyrfkmcu2h">
            Another practice is coming. Another match. Another week to organize. Another set of
            drills to choose. Another problem to correct. Another session to prepare.
          </p>
          <p data-id="element-48" data-mp="zxehccba867j">
            You can keep building every practice separately... Or start using an organized system
            that helps you plan, select, coach, compete, correct, and progress.
          </p>
          <p className="font-semibold text-white" data-id="element-49" data-mp="2h4suuvjjai0n">
            Plan your practice. Select your drills. Coach your session. Train real game situations.
            Correct match problems. Organize your season.
          </p>
        </div>

        <a href={OFFER_ANCHOR} className="mb-2 block" aria-label="Go to the purchase section" data-id="element-50" data-mp="2qzuh9jmfd5zj">
          <img src={PRODUCT_IMG} alt={PRODUCT_ALT} className="mx-auto w-full max-w-[200px] object-contain drop-shadow-2xl transition-transform duration-200 ease-out hover:scale-[1.02]" data-id="element-51" data-mp="2v1g2bs944qkt" />
        </a>

        <div className="mb-2 rounded-xl border border-brand-gold/40 bg-white/10 p-3" data-id="element-52" data-mp="39syfzjei2910">
          <p className="font-display text-xl uppercase leading-none tracking-wide text-white sm:text-3xl" data-id="element-53" data-mp="3errsp9lypw04">
            VOLLEYBALL COACH PRO™
          </p>
          <p className="mb-1 font-head text-[11px] font-medium text-brand-gold sm:text-sm" data-id="element-54" data-mp="3itd1ojvdlq51">
            Complete 6-in-1 Ready-to-Use Volleyball Coaching System + 5 Premium Bonuses
          </p>
          <p className="text-sm sm:text-lg" data-id="element-55" data-mp="1eqtht8hj2d1y">
            <span className="text-white/60 line-through" data-id="element-56" data-mp="1sgexoa016c5r">Regular Price: {PRICE_FULL}</span> |{' '}
            <span className="font-head font-bold text-brand-gold" data-id="element-57" data-mp="1nq6usb4v1jrf">TODAY ONLY: {PRICE_TODAY}</span>
          </p>
        </div>

        <CTAButton href={CHECKOUT_URL} className="mx-auto mb-2 max-w-md" data-id="element-58" data-mp="22drya65ndkzv">
          🚀 YES! I WANT VOLLEYBALL COACH PRO™
        </CTAButton>

        <div className="flex flex-wrap items-center justify-center gap-x-4 gap-y-1 text-[11px] font-semibold text-white/90 sm:text-sm" data-id="element-59" data-mp="1xhuiq227kio5">
          <span className="flex items-center gap-1" data-id="element-60" data-mp="27debwgpe1397">
            <ZapIcon className="h-4 w-4 text-brand-gold" aria-hidden="true" data-id="element-61" data-mp="27epck7njduw3" />
            Immediate Access • Digital Delivery by Email
          </span>
          <span className="flex items-center gap-1" data-id="element-62" data-mp="d0essdlstqx6">
            <StarIcon className="h-4 w-4 fill-brand-gold text-brand-gold" aria-hidden="true" data-id="element-63" data-mp="d1zlrysgt1sx" />
            ⭐⭐⭐⭐⭐ 4.9/5 — Verified Customer Reviews
          </span>
          <span className="flex items-center gap-1" data-id="element-64" data-mp="6wi7qh5f71cc">
            <ShieldCheckIcon className="h-4 w-4 text-brand-gold" aria-hidden="true" data-id="element-65" data-mp="3pbkfhh38fdc2" />
            🛡️ 14-Day Money-Back Guarantee
          </span>
        </div>
      </div>
    </section>;
}